<template>
  <div :class="{'_open': isOpenInner, '_toggle': toggle}"
       class="resume-section">
    <div @click.prevent="onToggle"
         class="resume-section__head">
      <slot name="icon"></slot>
      <h2 class="resume-section__title">
        {{ title }}
        <span v-if="typeof count === 'number'"
              class="resume-section__title-count">({{ count }})</span>
      </h2>
      <div v-if="toggle"
           class="resume-section__toggle">
        <BaseSvg name="ico-arrow-down-2"/>
      </div>
    </div>
    <collapse-transition @after-leave="afterLeave">
      <div v-show="isOpenInner"
           class="resume-section__content-wrap">
        <div v-if="tabs && tabs.length"
             class="resume-section__head-tabs">
          <div class="resume-section__head-tabs-content">
            <button v-for="(tab, index) in tabs"
                    :key="tab.country_id + '' + index"
                    @click.prevent="$emit('tab-click', index)"
                    :class="{_active: index === activeTab}"
                    class="resume-section__head-tab">
              <template v-if="tab.direction_id && tab.direction">
                {{ tab.country }} - {{ tab.direction.title }}
              </template>
              <template v-else>
                {{ tab.country }}
              </template>
            </button>
          </div>
        </div>

        <div class="resume-section__content">
          <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'ResumeSection',
    components: {
      CollapseTransition
    },
    props: {
      toggle: {
        type: Boolean,
        default: false
      },
      isOpen: {
        type: Boolean,
        default: true
      },
      title: String,
      tabs: Array,
      activeTab: Number,
      count: Number
    },
    data(vm) {
      return {
        isOpenInner: vm.isOpen,
      }
    },
    methods: {
      onToggle() {
        if (!this.toggle) return

        this.isOpenInner = !this.isOpenInner
      },
      afterLeave() {
        console.log('afterLeave')
      }
    }
  }
</script>

<style lang="less">

</style>
